import { gql } from '@apollo/client';
import { HIGHLIGHT_FIELDS } from './highlight';
import { PICTURE_FIELDS } from './picture';

export const CHAPTER_FIELDS = gql`
  ${PICTURE_FIELDS}
  ${HIGHLIGHT_FIELDS}
  fragment ChapterFields on Chapter {
    id
    explanation
    summary
    typeId
    pictures {
      ...PictureFields
    }
    highlights {
      ...HighlightFields
    }
    files {
      id
      title
      url
      videoId
      conceptId
    }
  }
`;

// used in cache updator
export const CHAPTER_WITH_HIGHLIGHT_FIELDS = gql`
  fragment ChapterWithHighlightFields on Chapter {
    highlights {
      start
      end
      text
      part
      tag
      color
    }
  }
`;
